//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
export default {
  name: "CommonSearch",
  components: {
    Sift: Sift
  },
  props: ["serve-id"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      labelData: [],
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0
    };
  },
  computed: {},
  created: function created() {
    this.fetchSiftData();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchSiftData: function fetchSiftData() {
      var _this = this;

      this.loading = true;
      this.$http.post("/queryTemplate/getTitleData", this.$qs.stringify({
        serveId: this.serveId
      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.siftData = data.resData.siftData;
          _this.labelData = data.resData.labelData;

          _this.$nextTick(function () {
            _this.initPage();
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;

      var obj = {};

      if (this.siftData.length > 0) {
        obj = this.$refs.needSift.getValue();
      }

      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;
      obj.serveId = this.serveId;
      this.loading = true;
      this.$http.get("/queryTemplate/pageList", {
        params: obj
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == 0) {
          _this2.list = data.resData.list;
          _this2.total = data.resData.total;
        }

        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    initPage: function initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage: function changePage(value) {
      this.pageNum = value;
      this.fetchList();
    }
  },
  watch: {},
  filters: {}
};